import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';
@Injectable({
  providedIn: 'root'
})
export class PushparentQuestionBankService {

  constructor(private backendService: BackendService) { }
  private path = '/push-parent-question-bank';


  savePushQuestionBank(pushparentqb) {
    return this.backendService.post(this.path + "/", pushparentqb);

  }



  searchParentQb(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };
    return this.backendService.post(this.path + "/search", data);
  }



  deleteQbank(tempId) {
    return this.backendService.post(this.path + '/delete/' + tempId, {});
  }

  getQbankbyId(id) {

    return this.backendService.get(this.path + '/' + id);
  }
}
